import { type ReactNode, createContext, useContext } from 'react';

export type RenderInlineBlock = (name: string) => ReactNode;

export type RenderInlineNumber = (name: string, value: ReactNode) => ReactNode;

export type InlineBlockRenderers = {
  renderBlock?: RenderInlineBlock;
  renderNumber?: RenderInlineNumber;
};

const InlineBlockRenderContext = createContext<
  InlineBlockRenderers | undefined
>(undefined);

export const InlineBlockRenderProvider = ({
  value,
  children,
}: {
  value?: InlineBlockRenderers;
  children: ReactNode;
}) => (
  <InlineBlockRenderContext.Provider value={value}>
    {children}
  </InlineBlockRenderContext.Provider>
);

export const useInlineBlockRenderers = (): InlineBlockRenderers | undefined =>
  useContext(InlineBlockRenderContext);
